import { Alert, Snackbar } from '@mui/material';

import React, { memo } from 'react';

import { SnackbarInterface } from './types';

interface SnackbarProps {
    handleCloseSnackbar: () => void;
    snackbar: SnackbarInterface;
};

const Toast = ({ snackbar, handleCloseSnackbar }: SnackbarProps) => {

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbar.open}
            onClose={handleCloseSnackbar}
            autoHideDuration={5000}
            sx={{ '&.MuiSnackbar-root': { top: '50px' }, }}
        >
            <Alert
                onClose={handleCloseSnackbar}
                severity={snackbar.severity}
                className='h-full'
            >
                {snackbar.message}
            </Alert>
        </Snackbar>
    )
}

export default memo(Toast);